import { render, staticRenderFns } from "./TransferInForm.vue?vue&type=template&id=62443853"
import script from "./TransferInForm.vue?vue&type=script&lang=js"
export * from "./TransferInForm.vue?vue&type=script&lang=js"
import style0 from "./TransferInForm.vue?vue&type=style&index=0&id=62443853&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports